import { Component } from '@angular/core';
import { CustomButtonComponent } from '../../shared/custom-button/custom-button.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [CustomButtonComponent, RouterLink],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
  public ELEMENT_IDS = ELEMENT_IDS;
}

const BASE_ELEMENT_ID: string = 'id_page_not_found';
export const ELEMENT_IDS: { [key: string]: string } = {
  'page': BASE_ELEMENT_ID + '_page',
  'img_illustration': BASE_ELEMENT_ID + '_img_illustration',
  'cnt_text': BASE_ELEMENT_ID + '_cnt_text',
  'lbl_title': BASE_ELEMENT_ID + '_lbl_title',
  'lbl_subtitle': BASE_ELEMENT_ID + '_lbl_subtitle',
  'btn_back_to_home': BASE_ELEMENT_ID + '_btn_back_to_home',
};
